module.exports = __webpack_public_path__ + "img/xtz.597982c1.svg";